import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { useContext } from 'react';
import Button from '../../../../common/base/Button';
import rule_form_props from '../../Connections/Forms/rules';
import { APIWebhook } from '../../../../../../../../typings/Webhook.interface';
import { APIDestination } from '../../../../../../../../typings/Destination.interface';
import { APISource } from '../../../../../../../../typings/Source.interface';
import { useToasts } from '../../../../common/Toast';
import { cleanseFormErrorObject } from '../../../../../utils/form';
const AddRules: React.FC<{
  context: {
    webhook: APIWebhook | null;
    source: APISource;
    destination: APIDestination;
  };
  mutateContext: (any) => void;
  nextStep: () => void;
}> = t0 => {
  const $ = _c(23);
  const {
    context: t1,
    mutateContext,
    nextStep
  } = t0;
  const {
    webhook,
    source,
    destination
  } = t1;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const t2 = webhook?.id;
  let t3;
  if ($[0] !== webhook) {
    t3 = rule_form_props.getInitialValues(webhook ? webhook.rules : undefined);
    $[0] = webhook;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = {
      rules: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== HookdeckAPI) {
    t5 = async v => cleanseFormErrorObject({
      rules: await rule_form_props.validate(v.rules, HookdeckAPI)
    });
    $[4] = HookdeckAPI;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== HookdeckAPI.webhooks || $[7] !== addToast || $[8] !== destination.id || $[9] !== mutateContext || $[10] !== nextStep || $[11] !== source.id || $[12] !== webhook) {
    t6 = (v_0, t7) => {
      const {
        resetForm
      } = t7;
      const values = {
        rules: rule_form_props.postprocessValues(v_0.rules),
        source_id: source.id,
        destination_id: destination.id
      };
      const promise = webhook ? HookdeckAPI.webhooks.update(webhook.id, values) : HookdeckAPI.webhooks.create(values);
      return promise.then(new_webhook => {
        mutateContext({
          webhook: new_webhook
        });
        resetForm({
          values: {
            rules: rule_form_props.getInitialValues(new_webhook.rules)
          }
        });
        if (webhook) {
          addToast("success", "Rules updated");
        }
        nextStep();
      }).catch(e => {
        addToast("error", `An error occurred while saving the rules${e.response?.data[0] ? `: ${e.response.data[0]}` : ""}`);
      });
    };
    $[6] = HookdeckAPI.webhooks;
    $[7] = addToast;
    $[8] = destination.id;
    $[9] = mutateContext;
    $[10] = nextStep;
    $[11] = source.id;
    $[12] = webhook;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== source.id || $[15] !== webhook) {
    t7 = t8 => {
      const {
        isValid,
        isSubmitting,
        handleSubmit
      } = t8;
      return <Form data-testid="guided-add-rules-form" onSubmit={handleSubmit}><rule_form_props.Fields source_id={source.id} display="full" prefix="rules" connection_name={webhook?.name} /><Div flex={{
          gap: 3
        }} m={{
          t: 6
        }}><Button submit={true} disabled={!isValid || isSubmitting} primary={!webhook} outline={!!webhook} icon={isSubmitting ? "loading" : undefined}>{webhook ? "Update" : "Next"}</Button></Div></Form>;
    };
    $[14] = source.id;
    $[15] = webhook;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <Formik key={t2} initialValues={t4} validate={t5} onSubmit={t6}>{t7}</Formik>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default AddRules;